module.exports = __webpack_public_path__ + "static/media/052-hot.7e0fb30d.svg";